import { PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { AdminParams, AdminStaff } from './adminStaff.types';
import { API_ROUTES } from '@/constants/apiRoutes';

export const getAdminStaffList = (client: AxiosInstance) => async (params: AdminParams) => {
  return (await client.get<PaginatedApiResponse<AdminStaff[]>>(API_ROUTES.GET_ADMIN_STAFF_LIST, { params })).data;
};

export const adminStaffListQueries = {
  all: () => ['admin-staff'],
  list: (params: AdminParams) =>
    queryFactoryOptions<PaginatedApiResponse<AdminStaff[]>>({
      queryKey: [...adminStaffListQueries.all(), 'list', params],
      queryFn: (client) => () => getAdminStaffList(client)(params),
    }),
};
